import React, { useEffect,useState } from 'react'

 

import Footer from '../../components/Footer';
import Header from '../../components/Header';
import MenuButtons from '../../components/MenuButtons';
import  CodeExport  from './components/CodeExport';
import toast from 'react-hot-toast';


function CreateTokenFree() {

  document.title = "Altcoinator | Free Erc20 Token Generator";
  
    const [name,setName] = useState("");
    const [symbol,setSymbol] = useState("");
    const [decimal,setDecimal] = useState(0);
    const [supply,setSupply] = useState(0);

    const [generatedCode,setgeneratedCode] = useState();

    const GenerateToken = () =>{
        if(name == "" || symbol == "" || decimal == "" || supply == ""){
            toast.error("You must fill in all fields");
        }else{
            
            setgeneratedCode(<CodeExport name={name} symbol={symbol} decimal={decimal} supply={supply} />)
        }
      
    }


     return ( 
        <>
        <div id="wrapper">
          <Header />
          
          <section className="tf-section tf-wallet"  >
            <div style={{maxWidth:"760px"}} className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="wallet-form">
                    <MenuButtons/>
                    <hr/>
                  <h4>Free ERC20 Token Generator</h4>
                  <p className="sub">This service gives you the solidity codes of the erc20 token you want to create. This service is free.</p>
                  <hr/>

                  
                  
                  <div style={{textAlign:"left"}}>

                       {generatedCode}


                          <div className='row'>
                          <div className='col-lg-6'>
                              <fieldset>
                              <label> Token Name* </label>
                              <input type="text" onChange={(e)=>{setName(e.target.value)}} value={name} placeholder="Ex: Bitcoin" required style={{background:"#171F29"}} />
                              </fieldset>
                          </div>
                          <div className='col-lg-6'>
                              <fieldset>
                              <label> Token Symbol* </label>
                              <input type="text" onChange={(e)=>{setSymbol(e.target.value)}} value={symbol} placeholder="Ex: BTC" required style={{background:"#171F29"}} />
                              </fieldset>
                          </div>
                          </div>
                          <br/>
                          <div className='row'>
                          <div className='col-lg-6'>
                              <fieldset>
                              <label> Token Decimal* </label>
                              <input type="number" onChange={(e)=>{setDecimal(e.target.value)}} value={decimal} placeholder="Ex: 18" min={1} max={18} required style={{background:"#171F29"}} />
                              </fieldset>
                          </div>
                          <div className='col-lg-6'>
                              <fieldset>
                              <label> Supply* </label>
                              <input type="number" onChange={(e)=>{setSupply(e.target.value)}} value={supply} placeholder="Ex: 21000000" min={1} required style={{background:"#171F29"}} />
                              </fieldset>
                          </div>
                          </div>
                      </div>

                      <div className="bottom">
                        <div className="wrap-btn mt-3">
                            <button type="submit"  onClick={GenerateToken} className="tf-button style2 w-100">
                             Generate Token
                            </button>
                        </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Footer/>
      </> 
  ); 

} 

export default CreateTokenFree;